exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".pOjd8 {\n  cursor: pointer;\n}\n", ""]);

// Exports
exports.locals = {
	"extIcon": "pOjd8"
};